const window = () =>
    import('./service/chat-window/chat-window.vue');

export default [
    // 客服
    {
        path: "/window",
        name: "window",
        components: {
            default: window,
        },
        meta: {
            nav: "window",
            navChild: "",
            navName:"接待中",
            keepAlive: false,
            hiddenNavigation:true
        },
    },
]



// WEBPACK FOOTER //
// ./src/views/window/index.js